<div class="header">
    <h2 class="title" color="accent" mat-dialog-title>{{'TITLE.CHANGE_LANGUAGE' | translate}} </h2>
    <span class="sub-title">{{'LANG.SUB_TITLE' | translate}}</span>
</div>
<mat-dialog-content class="content">
    <ng-container *ngFor="let lang of languages">
        <div [ngClass]="selected == lang.code ? 'language-selected' : 'language-select'" (click)="select(lang.code)">
            <img src="../../../assets/img/{{lang.code}}.svg" alt="">
            <p class="lang-name">{{"LANG." + lang.code | translate}}</p>
        </div>
    </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <div class="action">
        <button color="grey" mat-stroked-button (click)="close()">{{'LABEL.CANCEL' | translate}}</button>
        <button color="accent" mat-flat-button cdkFocusInitial (click)="onSave()">{{'LABEL.SAVE_CHANGE' | translate}}</button>
    </div>
</mat-dialog-actions>
